export default __webpack_public_path__ + "static/media/2.df7223b5.jpg";